module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/fr.json
// module id = 545
// module chunks = 0